export const SELECT_ORDER_DATA = "SELECT_ORDER_DATA";
export const CLEAN_ORDER_DATA = "CLEAN_ORDER_DATA";
